import type {Language, ValidationFn} from '@/types'

import React, {Component} from 'react'
import {join, tap, map} from 'ramda'
import {validate} from '@/validation'
import {connect} from 'react-redux'
import {appSelectors} from '@/store'

type Props = {
  l: Language,
  id: number,
  label: string,
  placeholder: string,
  value: string,
  onUpdate: () => void,
  validators: Array<ValidationFn>,
}

class RawEditTextInline extends Component<Props> {
  constructor (props) {
    super(props)

    this.state = {
      errors: [],
      isInput: false,
    }
  }

  toggleInput (flag) {
    if (this.state.errors.length === 0) {
      this.setState({isInput: flag})
    }
  }

  validate (e) {
    const recordErrors = (errors) => this.setState({errors})
    const resetErrors = () => this.setState({errors: []})

    return validate(this.props.validators, e.target.value)
      .mapFailure(tap(recordErrors))
      .map(tap(resetErrors))
  }

  updateList (e) {
    this.props.onUpdate(this.props.id, this.props.label, e.target.value)
    this.validate(e)
  }

  render = () =>
    <div className={this.state.errors.length > 0 ? 'form-group has-error' : 'form-group'}>
      {this.state.isInput
        ? <div>
          <input
            className="form-control"
            type="text"
            placeholder={this.props.placeholder}
            value={this.props.value}
            onChange={this.updateList.bind(this)}
            onBlur={() => this.toggleInput(false)}/>
          <div>{this.state.errors.length > 0 ? <span className='help-block'>{join(' ', map((error) => this.props.l(error), this.state.errors))}</span> : null}</div>
        </div>
        : <a className={this.props.value ? '' : 'empty-value'} onClick={() => this.toggleInput(true)}>{this.props.value}</a>
      }
    </div>
}
const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
})
export default connect(
  mapStateToProps,
)(RawEditTextInline)



// WEBPACK FOOTER //
// ./src/controls/edit-text-inline.js